/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.rs_template_global = {
    attach: function (context, settings) {
      // Add slideDown animation to Bootstrap dropdown when expanding.
      $('header .nav-item', context).on('show.bs.dropdown', function() {
        // Suppress dropdown behaviour for mobile menu.
        if (window.innerWidth < 992) {
          let linkTarget = $(this).find('a.nav-link').attr('href');
          window.location.href = linkTarget;
          return false;
        } else {
          $(this).find('.dropdown-menu').first().stop(true, true).slideDown(200);
        }
        if (window.innerWidth > 992) {
        // Setting column count on click so that safari recognizes the styling.
        $(this).find('.dropdown-menu').first().css("column-count", "3");
        }
      });

      // Add slideUp animation to Bootstrap dropdown when collapsing.
      $('header .nav-item', context).on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
        // Removing column count on collapse so that the style is refreshed for Safari
        $(this).find('.dropdown-menu').first().css("column-count", "auto");
      });

      $("#edit-reset-reports-search--2, #edit-reset-news-releases-view--2").on('click', function() {
        var form = $(this).parent().parent();
        form.find('input').val('');
        form.find('select').prop('selectedIndex',0);
      });

    }
  };

  $('#block-mainnavigation-2 .menu-item--expanded a').removeAttr("data-toggle");

  $('.file--application-pdf a').attr("target","_blank");


})(jQuery, Drupal);
